import type { AppPermission } from '@/types/app-permissions';

/** Permiso de la pantalla Privacidad (borrado a pedido, retención e historial). */
export const PERMISO_PRIVACIDAD = 'privacy.manage' satisfies AppPermission;
